import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { RodeoEvent } from 'model/rodeoEvent';

@Component({
    selector: 'entry-logs',
    templateUrl: 'entry-logs.html'
})
export class EntryLogsPage {
    logs: any[];
    rodeoEvent: RodeoEvent = null;

    constructor(navParams: NavParams, private viewController: ViewController) {
        this.rodeoEvent = navParams.get('rodeoEvent');
        this.logs = navParams.get('logs');

        this.logs.sort((a, b) => {
            if (a.time > b.time)
                return -1;
            else if (a.time < b.time)
                return 1;
            
            return 0;
        });
    }

    cancel() {
        this.viewController.dismiss();
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/entries/entry-logs.ts